<div
  *ngIf="multiBuyer"
  class="multi-buyer-header text-white text-center py-2 mb-0 w-100"
  (click)="selectMultiBuyer()"
>
  Logged in as
  <b class="font-weight-bold">{{ multiBuyer.nm }}</b>
  Account
  <i class="fa fa-caret-down ml-1"></i>
</div>
